import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import ContractorUpdate from "./ContractorUpdate";
import { useContractorData } from "../hooks";
import { memo } from "react";
import TaxStatus from "@/components/TaxStatus";
import {
  Module,
  PATH_USER,
  PATH_TIMESHEET_ENTRIES_CONTRACTOR_VISITS,
} from "@/constants";
import { DetailsButton } from "@/components/DetailsButton";
import { DetailField } from "@/components/DetailField";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";

const ContractorDetails = memo(() => {
  const { t } = useTranslation();
  const contractor = useContractorData();
  const usersPermissions = useModulePermissions(Module.Users);

  if (!contractor) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("contractors.details.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <DetailField label={t("contractors.fields.user_ref_number")}>
            {contractor.user_ref_number}
          </DetailField>
          <DetailField label={t("contractors.fields.personal_id_number")}>
            {contractor.personal_id_number}
          </DetailField>
          <DetailField label={t("contractors.fields.birth_date")}>
            {contractor.birth_date}
          </DetailField>
          <DetailField label={t("contractors.fields.gender")}>
            {contractor.gender ? t(`gender.${contractor.gender}`) : ""}
          </DetailField>
          <DetailField label={t("contractors.fields.registered_by_name")}>
            {contractor.registered_by_name}
          </DetailField>
          <DetailField label={t("contractors.fields.tax_status")}>
            <TaxStatus value={contractor.tax_status} className="w-full" />
          </DetailField>
          <DetailField label={t("contractors.fields.is_active")}>
            <Badge variant={contractor.is_active ? "secondary" : "destructive"}>
              {contractor.is_active
                ? t("contractors.status.active")
                : t("contractors.status.inactive")}
            </Badge>
          </DetailField>
          {contractor.user_id && usersPermissions.can_read && (
            <DetailField label={t("contractors.details.userCard")}>
              <DetailsButton
                path={PATH_USER}
                pathParams={{ userId: contractor.user_id }}
                label="contractors.details.userDetailsButton"
              />
            </DetailField>
          )}
          <DetailField label={t("contractors.details.timesheet")}>
            <DetailsButton
              path={PATH_TIMESHEET_ENTRIES_CONTRACTOR_VISITS}
              pathParams={{ userId: contractor.id, shiftReportId: null }}
              label="contractors.details.timesheetLink"
            />
          </DetailField>
        </dl>

        <Separator className="my-6" />

        <ContractorUpdate />
      </CardContent>
    </Card>
  );
});

export default ContractorDetails;
